var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "infoBox" }, [
    _c("div", { staticClass: "headline textAlignCenter" }, [
      _vm._v("Profil Status")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "progressRound",
        attrs: {
          "data-toggle": "tooltip",
          "data-placement": "top",
          title: "",
          "data-original-title": "Your progress"
        }
      },
      [
        _vm.currentCompletion >= 0.5
          ? _c("div", { staticClass: "clip-1" }, [
              _c("div", {
                staticClass: "slice-1",
                staticStyle: {
                  "-webkit-transform": "rotate(180deg)",
                  "-moz-transform": "rotate(180deg)",
                  "-o-transform": "rotate(180deg)",
                  transform: "rotate(180deg)"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentCompletion < 0.5
          ? _c("div", { staticClass: "clip-1" }, [
              _c("div", {
                staticClass: "slice-1",
                style: {
                  "-webkit-transform":
                    "rotate(" + 360 * _vm.currentCompletion + "deg)",
                  "-moz-transform":
                    "rotate(" + 360 * _vm.currentCompletion + "deg)",
                  "-o-transform":
                    "rotate(" + 360 * _vm.currentCompletion + "deg)",
                  transform: "rotate(" + 360 * _vm.currentCompletion + "deg)"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentCompletion <= 0.5
          ? _c("div", { staticClass: "clip-2" }, [
              _c("div", {
                staticClass: "slice-2",
                staticStyle: {
                  "-webkit-transform": "rotate(0deg)",
                  "-moz-transform": "rotate(0deg)",
                  "-o-transform": "rotate(0deg)",
                  transform: "rotate(0deg)"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentCompletion > 0.5
          ? _c("div", { staticClass: "clip-2" }, [
              _c("div", {
                staticClass: "slice-2",
                style: {
                  "-webkit-transform":
                    "rotate(" + 360 * (_vm.currentCompletion - 0.5) + "deg)",
                  "-moz-transform":
                    "rotate(" + 360 * (_vm.currentCompletion - 0.5) + "deg)",
                  "-o-transform":
                    "rotate(" + 360 * (_vm.currentCompletion - 0.5) + "deg)",
                  transform:
                    "rotate(" + 360 * (_vm.currentCompletion - 0.5) + "deg)"
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.completionLabel) + "%")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-563942c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563942c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileCompletion.vue
// module id = 587
// module chunks = 2